import { Link } from "react-router-dom";
import { aboutData } from "@/mocks/siteData";
import Breadcrumb from "@/components/base/Breadcrumb";
import SEOHead from "@/components/base/SEOHead";

const aboutBannerUrl =
  "https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20manga%20and%20art%20books%20on%20shelves%2C%20warm%20natural%20lighting%20from%20large%20windows%2C%20collaborative%20team%20environment%2C%20clean%20and%20minimalist%20design%2C%20professional%20and%20creative%20atmosphere%2C%20soft%20neutral%20color%20palette&width=1600&height=500&seq=about-banner-hero&orientation=landscape";

export default function About() {
  return (
    <>
      <SEOHead
        title="关于我们 - 本子漫画导航"
        description={`${aboutData.intro.substring(0, 120)}`}
        keywords="本子漫画,关于我们,本子漫画导航,漫画同人志,品牌介绍"
        canonicalPath="/about"
      />
      <div className="min-h-screen bg-background-50 pt-16">
        {/* Banner */}
        <div className="relative h-48 md:h-64 overflow-hidden">
          <img src={aboutBannerUrl} alt="关于我们" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4">
              <h1 className="text-2xl md:text-3xl font-bold text-white">关于我们</h1>
              <p className="text-white/70 text-sm md:text-base mt-2">{aboutData.tagline}</p>
            </div>
          </div>
        </div>

        <Breadcrumb />

        {/* Brand Intro */}
        <section className="py-14 md:py-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">品牌介绍</h2>
              <p className="text-foreground-600 leading-relaxed">{aboutData.intro}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-16">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center p-5 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">{stat.value}</div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Story */}
            <div className="bg-background-100 rounded-lg p-6 md:p-8 mb-12">
              <h3 className="text-lg font-semibold text-foreground-950 mb-3">我们的故事</h3>
              <p className="text-foreground-600 leading-relaxed text-sm">{aboutData.story}</p>
            </div>

            {/* Values */}
            <h3 className="text-lg font-semibold text-foreground-950 mb-5 text-center">我们的价值观</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12">
              {aboutData.values.map((v) => (
                <div key={v.title} className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <h4 className="font-semibold text-foreground-950 mb-2">{v.title}</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">{v.description}</p>
                </div>
              ))}
            </div>

            {/* Contact */}
            <div className="text-center bg-accent-100/50 rounded-lg p-6 md:p-8">
              <h3 className="text-lg font-semibold text-foreground-950 mb-4">联系我们</h3>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-foreground-600">
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-accent-600"></i>
                  <span>{aboutData.contact.email}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-weibo-line text-accent-600"></i>
                  <span>{aboutData.contact.weibo}</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-wechat-line text-accent-600"></i>
                  <span>{aboutData.contact.wechat}</span>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-12">
              <p className="text-foreground-600 mb-4 text-sm">想要了解更多本子漫画相关内容？</p>
              <Link
                to="/category/ziyuan-tuijian"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始探索资源
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* JSON-LD */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              name: "关于本子漫画导航",
              description: aboutData.intro,
              url: typeof window !== "undefined" ? window.location.origin + __BASE_PATH__ + "/about" : "",
              mainEntity: {
                "@type": "Organization",
                name: aboutData.brandName,
                description: aboutData.tagline,
                contactPoint: {
                  "@type": "ContactPoint",
                  email: aboutData.contact.email,
                  contactType: "customer service",
                },
              },
            }),
          }}
        />
      </div>
    </>
  );
}